import { all } from 'redux-saga/effects';

import { SagasGenerator } from '@gss/types/shared';

import { globalSagas } from './globalSagas';

export function* rootSagas(): SagasGenerator {
  yield all([...globalSagas]);
}
